export default "__VITE_ASSET__GErABjuW__"